import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';

export const Login = () => {
    const { authState, oktaAuth } = useOktaAuth();

    useEffect(() => {
        if (!authState) {
            return;
        }
        if (!authState.isAuthenticated) {
            oktaAuth.signInWithRedirect({ originalUri: '/home' });
        }
    }, [authState, oktaAuth]);

    return null;
};

export default Login;
